import { ERROR_MESSAGES } from 'core/constants/errorMessages';
import { validateTemplatedInputVariables } from 'core/utils/validators/validateTemplatedInputVariables';
import { getCampaignCreationTemplateVariables } from 'pages/CampaignCreation/utils/getCampaignCreationTemplateVariables';
import { CampaignType } from 'services/campaign/types';
import Yup from 'utils/validation';

export const campaignHumanOutreachVariables =
  getCampaignCreationTemplateVariables(CampaignType.HUMAN_OUTREACH);

const validationObject = {
  title: Yup.string().required('Enter a title').min(1, 'Title is too short'),
  customTemplatedMessage: Yup.string().required('Enter an opening message')
};

validationObject.customTemplatedMessage =
  validationObject.customTemplatedMessage.test(
    'variable-validation',
    ERROR_MESSAGES.templatedInputVariableMustBeValid,
    (value) => {
      if (!value) return true;

      return validateTemplatedInputVariables({
        variables: campaignHumanOutreachVariables,
        value
      });
    }
  );

export const createCampaignWithParticipantsSchema =
  Yup.object().shape(validationObject);
